import { render, staticRenderFns } from "./tabela.vue?vue&type=template&id=0261c1ac&"
import script from "./tabela.vue?vue&type=script&lang=js&"
export * from "./tabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports